import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';
import NoSSR from 'react-no-ssr';
import styles from './index.css';
import SingleImg from '../singleImg';
import { getHuaweiRecommend } from '../../../../services/api';

class RelateNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        relateNewsDate: [],
    };

    async componentDidMount() {
        const { content } = this.props;
        const type = content.docType || 'video';
        const id = content.guid || content.base62Id || '';
        const title = content.title || '';
        let relateNewsDate = await getHuaweiRecommend(type, title, id);

        relateNewsDate = relateNewsDate.map(item => {
            return {
                title: item.title || '',
                ESsourceAlias: item.source || (item.phvideo && item.phvideo.channelName) || '',
                thumbnail: item.thumbnail && item.thumbnail.replace(/_webp|.webp/g, ''),
                commentUrl: item.commentsUrl || item.documentId || item.id,
                type: item.type === 'phvideo' ? 'video' : item.type,
                duration: (item.phvideo && item.phvideo.length) || '',
                slideCount: (item.style && item.style.slideCount) || '',
                base62Id:
                    (item.link &&
                        item.link.weburl &&
                        item.link.weburl
                            .split('?')[0]
                            .split('/')
                            .pop()) ||
                    '',
            };
        });

        this.setState({
            relateNewsDate,
        });
    }

    render() {
        /**
         * 组件分发数据
         */
        const { relateNewsDate } = this.state;
        const { content } = this.props;

        return (
            <div className={styles.relateNews}>
                <div className={styles.relateHeader}>
                    <h2 className={styles.relateTitle}>{content.moduleName}</h2>
                    {relateNewsDate.length > 0 &&
                        relateNewsDate
                            .slice(0, 3)
                            .map((item, index) => (
                                <SingleImg content={item} countNum={3} liveNum={index + 1} key={index} />
                            ))}
                    {/* <NoSSR>
                        <Ad content={content.adNews} />
                    </NoSSR> */}
                </div>
            </div>
        );
    }
}

export default errorBoundary(RelateNews);
